import { render, staticRenderFns } from "./update-item-request.vue?vue&type=template&id=74037d8b&"
import script from "./update-item-request.vue?vue&type=script&lang=js&"
export * from "./update-item-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports